import React, { useEffect, useState } from "react";
import {
  Typography,
  Paper,
  Divider,
  IconButton,
  FormGroup,
  FormControlLabel,
} from "@mui/material";
import { ReactComponent as Rotate } from "../../assets/images/Rotate.svg";
import "../../styles/partCreation.css";
import { ReactComponent as ButtonPlus } from "../../assets/images/ButtonPlus.svg";
import { automationHttpRequest } from "../../api/httpRequests";
import FormControl from "@mui/material/FormControl";
import { ReactComponent as DropdownIcon } from "../../assets/images/DropdownIcon.svg";
import { Select, MenuItem, InputAdornment, TextField } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import Tooltip from "@mui/material/Tooltip";

const PartInformation = ({
  setPartInformationData,
  handleContinue,
  setEquipment_number_for_bom,
}) => {
  const [abcIndicator, setAbcIndicator] = useState({
    abcIndicatorFutureValue: "",
    // abcIndicatorJustify: ""
  });
  const [minimumValue, setMinimumValue] = useState({
    minimumFutureValue: "",
    // minimumValueJustify: ""
  });
  const [maximumValue, setMaximumValue] = useState({
    maximumFutureValue: "",
    // maximumValueJustify: ""
  });
  const [criticalityIndicator, setCriticalityIndicator] = useState("");
  const [sloc, setSloc] = useState("4010");
  const [bin, setBin] = useState("");
  const [inputCount, setInputCount] = useState(1);
  const [inputValues, setInputValues] = useState([""]);
  const ABCoptions = [
    "A : Significant Material",
    "B : Medium Significance",
    "C : Low significance",
  ];

  const handleSelectABCChange = (event) => {
    setAbcIndicator((prevObject) => ({
      ...prevObject,
      abcIndicatorFutureValue: event?.target?.value,
    }));
    setPartInformationData((prevObject) => ({
      ...prevObject,
      ABC_indicator: event?.target?.value,
    }));
  };
  useEffect(() => {
    setPartInformationData((prevObject) => ({
      ...prevObject,
      ABC_indicator: "A : Significant Material",
    }));
  }, []);

  const inputStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "baseline",
    width: "25%",
  };

  const headingStyle = {
    fontWeight: "700",
  };

  useEffect(() => {
    setPartInformationData((prevObject) => ({
      ...prevObject,
      storage_location: sloc,
    }));
  }, []);

  const handleFutureValue = (event) => {
    if (event?.target?.name === "abcIndicator") {
      setAbcIndicator((prevObject) => ({
        ...prevObject,
        abcIndicatorFutureValue: event?.target?.value,
      }));
      setPartInformationData((prevObject) => ({
        ...prevObject,
        ABC_indicator: event?.target?.value,
      }));
    }
    if (event?.target?.name === "minimumValue") {
      const numericValue = parseInt(event?.target?.value, 10);
      if ((!isNaN(numericValue) && numericValue != "") || numericValue === 0) {
        setMinimumValue((prevObject) => ({
          ...prevObject,
          minimumFutureValue: numericValue,
        }));
        setPartInformationData((prevObject) => ({
          ...prevObject,
          minimum_stock_level: numericValue,
        }));
      }
      if (event?.target?.value === "") {
        setMinimumValue((prevObject) => ({
          ...prevObject,
          minimumFutureValue: "",
        }));
        setPartInformationData((prevObject) => ({
          ...prevObject,
          minimum_stock_level: "",
        }));
      }
    }
    if (event?.target?.name === "maximumValue") {
      // if (parseInt(event?.target?.value, 10) < parseInt(minimumValue?.minimumFutureValue, 10)) {
      //   toast.error("Maximum Stock should be greater than Minimum Stock.", {
      //     position: toast.POSITION.TOP_CENTER,
      //     autoClose: 800,
      //   });
      // }
      if (
        parseInt(event?.target?.value, 10) <
          parseInt(minimumValue?.minimumFutureValue, 10) ||
        (parseInt(event?.target?.value, 10) === 0 &&
          parseInt(minimumValue?.minimumFutureValue, 10) === 0)
      ) {
        toast.error("Maximum Stock should be greater than Minimum Stock.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 800,
        });
      }
      const numericValue = parseInt(event?.target?.value, 10);
      if ((!isNaN(numericValue) && numericValue != "") || numericValue === 0) {
        setMaximumValue((prevObject) => ({
          ...prevObject,
          maximumFutureValue: numericValue,
        }));
        setPartInformationData((prevObject) => ({
          ...prevObject,
          maximum_stock_level: numericValue,
        }));
      }
      if (event?.target?.value === "") {
        setMaximumValue((prevObject) => ({
          ...prevObject,
          maximumFutureValue: "",
        }));
        setPartInformationData((prevObject) => ({
          ...prevObject,
          maximum_stock_level: "",
        }));
      }
    }
    if (event?.target?.name === "criticalityIndicator") {
      setCriticalityIndicator(event?.target?.value);
      setPartInformationData((prevObject) => ({
        ...prevObject,
        critical_part: event?.target?.value,
      }));
    }
    if (event?.target?.name === "sloc") {
      setSloc(event?.target?.value);
      setPartInformationData((prevObject) => ({
        ...prevObject,
        storage_location: event?.target?.value,
      }));
    }
    if (event?.target?.name === "bin") {
      if (event?.target?.value.length <= 10) {
        setBin(event?.target?.value);
        setPartInformationData((prevObject) => ({
          ...prevObject,
          storage_bin: event?.target?.value,
        }));
      } else {
        toast.error("Limit Exceeded.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 800,
        });
      }
    }
  };

  const handleIndicatorSelectChange = (event) => {
    // setChecked(!checked)
    let val = event.target.checked ? "X" : "";
    setCriticalityIndicator(val);
    setPartInformationData((prevObject) => ({
      ...prevObject,
      critical_part: val,
    }));
    // setCriticalityIndicator(event?.target.value);
  };

  // const handleIndicatorSelectChange = (event) => {
  //   setCriticalityIndicator(event?.target?.value)
  //   setPartInformationData((prevObject) => ({
  //     ...prevObject,
  //     critical_part: event?.target?.value,
  //   }));
  // }
  // const handleJustification = (event) => {
  //   if (event?.target?.name === "abcIndicator") {
  //     setAbcIndicator((prevObject) => ({
  //       ...prevObject,
  //       abcIndicatorJustify: event?.target?.value,
  //     }));
  //     setPartInformationData((prevObject) => ({
  //       ...prevObject,
  //       justification_for_change_in_abc_indicator: event?.target?.value,
  //     }));
  //   }
  //   if (event?.target?.name === "minimumValue") {
  //     setMinimumValue((prevObject) => ({
  //       ...prevObject,
  //       minimumValueJustify: event?.target?.value,
  //     }));
  //     setPartInformationData((prevObject) => ({
  //       ...prevObject,
  //       justification_for_change_in_minimum_stock: event?.target?.value,
  //     }));
  //   }
  //   if (event?.target?.name === "maximumValue") {
  //     setMaximumValue((prevObject) => ({
  //       ...prevObject,
  //       maximumValueJustify: event?.target?.value,
  //     }));
  //     setPartInformationData((prevObject) => ({
  //       ...prevObject,
  //       justification_for_change_in_maximum_stock: event?.target?.value,
  //     }));
  //   }
  // }

  const handleInputChange = (index, value) => {
    const numericValue = parseInt(value, 10);
    if (!isNaN(numericValue) && numericValue != "") {
      const newInputValues = [...inputValues];
      newInputValues[index] = numericValue;
      setInputValues(newInputValues);
      setEquipment_number_for_bom(newInputValues);
    }
    if (value === "") {
      const newInputValues = [...inputValues];
      newInputValues[index] = "";
      setEquipment_number_for_bom(newInputValues);
      setInputValues(newInputValues);
    }
  };

  const handleAddInput = () => {
    setInputCount(inputCount + 1);
    setInputValues([...inputValues, ""]);
  };

  return (
    <>
      <Paper
        sx={{
          width: "100%",
          // height: "100px",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          alignItems: "stretch",
          margin: "20px 0px",
          borderRadius: "18px",
          padding: "20px 0px",
        }}
        elevation={2}
      >
        <Typography className="plantdata">Plant Specific Data</Typography>
        <div className="value_Display">
          <Typography className="subHeading"></Typography>
          <Typography style={{ fontWeight: 600, margin: "20px 0px 20px 40px" }}>
            Proposed Value
          </Typography>
        </div>
        <div className="value_Display">
          <Typography className="subHeading">
            ABC Indicator{" "}
            <span style={{ color: "#C6003D", margin: "4px", fontSize: "14px" }}>
              *
            </span>{" "}
          </Typography>
          {/* <input
                  // //placeholder="future Value"
                  name="abcIndicator"
                  type="text"
                  className="narrow_input"
                  value={abcIndicator?.abcIndicatorFutureValue}
                  onChange={handleFutureValue}
                /> */}
          <Tooltip
            title={abcIndicator?.abcIndicatorFutureValue || ""}
            placement="top"
          >
            <FormControl sx={{ width: "100px", margin: "0px 20px 8px 50px" }}>
              <Select
                value={abcIndicator?.abcIndicatorFutureValue}
                onChange={handleSelectABCChange}
                IconComponent={(props) => (
                  <DropdownIcon
                    {...props} // Pass down required props for proper functionality
                    style={{
                      width: "30px",
                      height: "08px",
                      position: "absolute",
                      top: "50%",
                      right: "10px",
                      transform: "translateY(-50%)",
                    }}
                  />
                )}
                sx={{ height: "32px" }}
              >
                {ABCoptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Tooltip>
          {/* <input
                  // //placeholder="Justify Value"
                  name="abcIndicator"
                  // disabled= {abcIndicator?.abcIndicatorFutureValue.length > 0 ? false : true}
                  type="text"
                  // style= {{
                  //   background : abcIndicator?.abcIndicatorFutureValue.length > 0 ? "#FFF" : "#EFEFEF" 
                  // }}
                  className="narrow_input"
                  value={abcIndicator?.abcIndicatorJustify}
                  onChange={handleJustification}
                /> */}
        </div>
        <Divider />
        <div className="value_Display">
          <Typography className="subHeading">Criticality Indicator</Typography>
          {/* <input
                  //placeholder="future Value"
                  name="criticalityIndicator"
                  type="text"
                  className="narrow_input"
                  autoComplete="off"
                  value={criticalityIndicator}
                  onChange={handleFutureValue}
                /> */}
          {/* <FormControl sx={{
            borderRadius: "8px",
            margin: "10px 20px 10px 50px !important",
            width: "100px",
            outlineStyle: "none",
            border: "1px solid #cbc3c3",
            textAlign: "center"
          }}>
            <Select
              value={criticalityIndicator}
              onChange={handleIndicatorSelectChange}
              renderValue={(selected) => (
                <div>
                  <span key={selected}>{selected}</span>
                </div>
              )}
              sx={{
                padding: "0px !important",
                height: "32px"
              }}
            >
              <MenuItem value="">
                <Checkbox checked={criticalityIndicator === ""} />
                <ListItemText primary="Blank" />
              </MenuItem>
              <MenuItem value="X">
                <Checkbox checked={criticalityIndicator === "X"} />
                <ListItemText primary="X" />
              </MenuItem>
            </Select>
          </FormControl> */}
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={criticalityIndicator === "X"}
                  style={{
                    color: "#575555",
                    position: "relative",
                    left: "85px",
                  }}
                  onChange={handleIndicatorSelectChange}
                />
              }
              // label="My Checkbox"
            />
          </FormGroup>
        </div>
        <Divider />
        <div className="value_Display">
          <Typography className="subHeading">
            Minimum Stock{" "}
            <span style={{ color: "#C6003D", margin: "4px", fontSize: "14px" }}>
              *
            </span>{" "}
          </Typography>
          <input
            //placeholder="future Value"
            name="minimumValue"
            type="text" // Change type to text
            pattern="[0-9]*"
            inputmode="numeric"
            className="narrow_input partInputFieldEq"
            autoComplete="off"
            value={minimumValue?.minimumFutureValue}
            onChange={handleFutureValue}
          />
          {/* <input
                  //placeholder="Justify Value"
                  name="minimumValue"
                  // disabled= {abcIndicator?.abcIndicatorFutureValue.length > 0 ? false : true}
                  type="text"
                  // style= {{
                  //   background : abcIndicator?.abcIndicatorFutureValue.length > 0 ? "#FFF" : "#EFEFEF" 
                  // }}
                  className="narrow_input"
                  value={minimumValue?.minimumValueJustify}
                  onChange={handleJustification}
                /> */}
        </div>
        <Divider />
        <div className="value_Display">
          <Typography className="subHeading">
            Maximum Stock{" "}
            <span style={{ color: "#C6003D", margin: "4px", fontSize: "14px" }}>
              *
            </span>{" "}
          </Typography>
          <input
            //placeholder="future Value"
            name="maximumValue"
            type="text" // Change type to text
            pattern="[0-9]*"
            inputmode="numeric"
            className="narrow_input partInputFieldEq "
            value={maximumValue?.maximumFutureValue}
            onChange={handleFutureValue}
            autoComplete="off"
          />
          {/* <input
                  //placeholder="Justify Value"
                  name="maximumValue"
                  // disabled= {abcIndicator?.abcIndicatorFutureValue.length > 0 ? false : true}
                  type="text"
                  // style= {{
                  //   background : abcIndicator?.abcIndicatorFutureValue.length > 0 ? "#FFF" : "#EFEFEF" 
                  // }}
                  className="narrow_input"
                  value={maximumValue?.maximumValueJustify}
                  onChange={handleJustification}
                /> */}
        </div>
        <Divider />
        <div className="value_Display">
          <Typography className="subHeading">
            Storage Location{" "}
            <span style={{ color: "#C6003D", margin: "4px", fontSize: "14px" }}>
              *
            </span>{" "}
          </Typography>
          <input
            //placeholder="future Value"
            name="sloc"
            type="text"
            className="narrow_input"
            value={sloc}
            onChange={handleFutureValue}
            autoComplete="off"
          />
        </div>
        <Divider />
        <div className="value_Display">
          <Typography className="subHeading">Bin </Typography>
          <input
            //placeholder="future Value"
            name="bin"
            type="text"
            className="narrow_input"
            value={bin}
            autoComplete="off"
            onChange={handleFutureValue}
          />
        </div>
        <Divider />
        <div style={{ margin: "0px 48px" }}>
          <Typography
            sx={{
              width: "100%",
              fontFamily: "Verdana",
              fontSize: "14px",
              fontWeight: "700",
              margin: "20px 0px",
            }}
          >
            Equipment Number(s) For BOM{" "}
            <span style={{ color: "#C6003D", margin: "4px", fontSize: "14px" }}>
              *
            </span>{" "}
          </Typography>
          <div>
            <div
              style={{ display: "flex", flexDirection: "column", width: "20%" }}
            >
              {Array.from({ length: inputCount }).map((_, index) => (
                <input
                  key={index}
                  className="partInputFieldEq"
                  type="text" // Change type to text
                  pattern="[0-9]*"
                  inputmode="numeric"
                  autoComplete="off"
                  value={inputValues[index]}
                  onChange={(e) => handleInputChange(index, e.target.value)}
                  minLength="0" // Change min to minLength
                  maxLength="10" // Assuming you want to limit the length of input
                />
              ))}
            </div>
            <IconButton onClick={handleAddInput} sx={{ height: "40px" }}>
              <ButtonPlus />
            </IconButton>
          </div>
        </div>
      </Paper>
      <ToastContainer />
    </>
  );
};

export default PartInformation;
